<template>
  <div>
    <img class="logo" src="https://ibliss-icons-prod.s3.us-east-1.amazonaws.com/marca_empresarial/image-welcomeDefault.png" />
    <v-navigation-drawer class="sidebar" v-model="drawer" mini-variant permanent>
      <v-list class="my-10">
        <template>
          <div>
            <v-list-item v-for="item in visibleItems" :key="item.title" :to="item.link" @click="handleItemClick(item)">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item-icon v-bind="attrs" v-on="on">
                    <v-icon color="primary">{{ item.icon }}</v-icon>
                  </v-list-item-icon>
                </template>
                <span>{{ item.title }}</span>
              </v-tooltip>
            </v-list-item>
            <v-list-item v-if="showMoreFunctionality" @click="openSheet">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item-icon v-bind="attrs" v-on="on">
                    <v-icon color="primary">mdi-dots-horizontal</v-icon>
                  </v-list-item-icon>
                </template>
                <span>{{ $t('sidebar.label.listOptions') }}</span>
              </v-tooltip>
            </v-list-item>
          </div>
        </template>
      </v-list>
      <v-list class="mt-8">
        <v-list-item class="mt-1" color="primary"  @click="salir">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon v-bind="attrs" v-on="on">
                <v-icon color="primary">mdi-logout</v-icon>
              </v-list-item-icon>
            </template>
            <span>{{ $t('button.exit') }}</span>
          </v-tooltip>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-menu v-model="sheet" :nudge-right="58" ref="menu" :position-x="menuPosition.x" :position-y="menuPosition.y">
      <v-card style="height: 420px; width: 400px; overflow-y: auto;">
        <v-card-text>
          <v-text-field v-model="searchQuery" :label="$t('label.searchFunctionality.title')" outlined dense @click.stop>
            <template v-slot:append>
              <v-icon>mdi-magnify</v-icon>
            </template>
          </v-text-field>
          <div class="row">
            <div class="col-4 col-md-4 d-flex flex-column align-items-center" v-for="item in filteredItemSubmenu"
              :key="item.title">
              <v-btn outlined block :href="item.link"
                class="d-flex align-items-center justify-content-center no-outline" style="max-width: 100px;">
                <v-icon color="#6E17A5" size="28">{{ item.icon }}</v-icon>
              </v-btn>
              <span class="mt-1 text-center" style="width: 100%;">{{ item.title }}</span>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-menu>
  </div>
</template>

<script>

import router from "@/router/index";
export default {
  name: "sidebar",
  data() {
    return {
      drawer: true,
      empresa: sessionStorage.getItem("empresa"),
      menuPosition: { x: 0, y: 0 },
      searchQuery: '',
      sheet: false,
      allowedScreens: [],
      role: sessionStorage.getItem('roleId'),
      items: [
        { title: this.$t('label.option.home'), icon: "mdi-home-outline", link: "/home", screen: "home" },
        { title: this.$t('label.option.marketplace'), icon: "mdi-store-outline", link: "/marketplace", screen: "marketplace" },
        { title: this.$t('label.option.board'), icon: "mdi-domain", link: "/board", screen: "board" },
        { title: this.$t('label.option.products'), icon: "mdi-cart-outline", link: "/product", screen: "product" },
        { title: this.$t('label.option.companies'), icon: "mdi-factory", link: "/companies", screen: "companies" },
        { title: this.$t('label.option.users'), icon: "mdi-account-cog-outline", link: "/users_admin", screen: "users_admin" },
        { title: this.$t('label.option.reserve'), icon: "mdi-folder-star-outline", link: "/buy_recognition", screen: "buy_recognition" },
        { title: this.$t('label.option.suppliers'), icon: "mdi-briefcase-check-outline", link: "/suppliers", screen: "suppliers" },
        { title: this.$t('label.option.reconciliation'), icon: "mdi-checkbox-marked-circle-outline", link: "/purchase_reconciliation", screen: "purchase_reconciliation" },
        { title: this.$t('label.option.assignment'), icon: "mdi-account-star-outline", link: "/shape_assignment", screen: "shape_assignment" },
        { title: this.$t('label.option.reports'), icon: "mdi-file-document-outline", link: "/reports", screen: "reports" },
        { title: this.$t('label.option.bonus'), icon: "mdi-gift-outline", link: "/bonus", screen: "bonus" },
        { title: this.$t('label.option.ads'), icon: "mdi-star-box-multiple-outline", link: "/ads", screen: "ads" },
        { title: this.$t('label.option.zenStar'), icon: "mdi-timer-star-outline", link: "/zen_star", screen: "zen_star" },
        { title: this.$t('label.option.mindSet'), icon: "mdi-head-cog-outline", link: "/mindset", screen: "mindset" },
        { title: this.$t('label.option.tipsCategories'), icon: "mdi-emoticon-happy-outline", link: "/tips-categories", screen: "tips-categories" },
        { title: this.$t('label.option.happinessTips'), icon: "mdi-emoticon-happy-outline", link: "/happiness-tips", screen: "happiness-tips" },
        { title: this.$t('label.option.surveys'), icon: "mdi-poll", link: "/surveys", screen: "surveys" }
      ],
      itemSubmenu: [],
    };
  },
  
  computed: {
    visibleItems() {
      return this.items.slice(0, 5);
    },
    showMoreFunctionality() {
    return this.itemSubmenu.length > 0;
  },
  filteredItemSubmenu() {
    return this.itemSubmenu.filter(item =>
      item.title.toLowerCase().includes(this.searchQuery.toLowerCase())
    );
   },
  },

  created() {
    this.loadAllowedScreens();
  },

  methods: {
    loadAllowedScreens() {
      const screens = JSON.parse(sessionStorage.getItem('allowedScreens')) || [];
      this.allowedScreens = Array.isArray(screens) ? screens : [];
      this.updateMenuItems();
    },

    updateMenuItems() {
      const allowedScreenKeys = this.allowedScreens;
      this.items = [
        { title: this.$t('label.option.home'), icon: "mdi-home-outline", link: "/home", screen: "home" },
        { title: this.$t('label.option.marketplace'), icon: "mdi-store-outline", link: "/marketplace", screen: "marketplace" },
        { title: this.$t('label.option.board'), icon: "mdi-domain", link: "/board", screen: "board" },
        { title: this.$t('label.option.products'), icon: "mdi-cart-outline", link: "/product", screen: "product" },
        { title: this.$t('label.option.companies'), icon: "mdi-factory", link: "/companies", screen: "companies" },
        { title: this.$t('label.option.users'), icon: "mdi-account-cog-outline", link: "/users_admin", screen: "users_admin" },
        { title: this.$t('label.option.reserve'), icon: "mdi-folder-star-outline", link: "/buy_recognition", screen: "buy_recognition" },
        { title: this.$t('label.option.suppliers'), icon: "mdi-briefcase-check-outline", link: "/suppliers", screen: "suppliers" },
        { title: this.$t('label.option.reconciliation'), icon: "mdi-checkbox-marked-circle-outline", link: "/purchase_reconciliation", screen: "purchase_reconciliation" },
        { title: this.$t('label.option.assignment'), icon: "mdi-account-star-outline", link: "/shape_assignment", screen: "shape_assignment" },
        { title: this.$t('label.option.reports'), icon: "mdi-file-document-outline", link: "/reports", screen: "reports" },
        { title: this.$t('label.option.bonus'), icon: "mdi-gift-outline", link: "/bonus", screen: "bonus" },
        { title: this.$t('label.option.ads'), icon: "mdi-star-box-multiple-outline", link: "/ads", screen: "ads" },
        { title: this.$t('label.option.zenStar'), icon: "mdi-timer-star-outline", link: "/zen_star", screen: "zen_star" },
        { title: this.$t('label.option.mindSet'), icon: "mdi-head-cog-outline", link: "/mindset", screen: "mindset" },
        { title: this.$t('label.option.tipsCategories'), icon: "mdi-emoticon-happy-outline", link: "/tips-categories", screen: "tips-categories" },
        { title: this.$t('label.option.happinessTips'), icon: "mdi-emoticon-happy-outline", link: "/happiness-tips", screen: "happiness-tips" },
        { title: this.$t('label.option.surveys'), icon: "mdi-poll", link: "/surveys", screen: "surveys" }
      ].filter(item => allowedScreenKeys.includes(item.screen));

      this.itemSubmenu = this.items.slice(5);
      this.items = this.items.slice(0, 5);
    },

    showListCompanies(itemTitle) {
      let empresa = sessionStorage.getItem("empresa").toLowerCase();
      empresa = empresa ? empresa.replace(/"/g, "").toLowerCase() : "";
      const menu = "Empresas";
      const luca = 'lucasian';

      // Verifica si lucasian es igual a 'lucasian' y si itemTitle no es 'Empresas'
      if (empresa === luca || itemTitle.toLowerCase() !== menu.toLowerCase()) {
        return true; // Muestra el elemento
      } else {
        return false; // No muestra el elemento si son iguales
      }
    },
    salir() {
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('user');
      sessionStorage.removeItem('idGroup');
      sessionStorage.removeItem('idUsuario');
      sessionStorage.removeItem('idEmpresa');
      router.push({ path: '/login' })
    },

    handleItemClick(item) {
      if (item.customAction === "openSheet") {
        this.openSheet();
      }
    },
    openSheet() {
      this.sheet = true;
      this.menuPosition.x = this.$refs.menu.$el.clientWidth
      this.menuPosition.y = event.clientY;
    },
    closeSheet() {
      this.sheet = false;
    }
  }
};
</script>

<style lang="css" scoped>
img {
  position: fixed;
  margin: 30px 0px 0px 0px;
  width: 4em;
}

.sidebar {
  top: 6rem !important;
  position: fixed;
  border-top-right-radius: 175px;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

.no-outline {
  border: none !important;
  outline: none !important;
}

.v-list-item__icon {
  margin-left: 0 !important;
}
</style>
